module.exports = __webpack_public_path__ + "media/images/design/images/h2_blog-5ff193b8f2115519dd98300c0a64bb7f.png";